import { PREBID_CONFIG } from '@/features/ads/internal/config/prebid-bids-config';
import { PrebidAdUnit } from '@/features/ads/internal/types/prebid';

export interface PbjsRequestBidsOptions {
  timeout?: number;
  adUnitCodes?: string[];
  bidsBackHandler?: () => void; // keep loose; you only log & continue
}

export interface Pbjs {
  que: Array<() => void>;

  setConfig(config: PrebidConfig): void;

  addAdUnits(adUnits: PrebidAdUnit[] | PrebidAdUnit): void;

  requestBids(options: PbjsRequestBidsOptions): void;

  removeAdUnit(adUnits: string[]): void;

  setTargetingForGPTAsync(): void;
}

type PbConsentManagement = {
  gdpr?: {
    cmpApi: 'iab' | 'static';
    timeout?: number;
    actionTimeout?: number;
    defaultGdprScope?: boolean;
    allowAuctionWithoutConsent?: boolean;
  };
  gpp?: {
    cmpApi: 'iab' | 'static';
    timeout?: number;
  };
};

type PrebidConfig = typeof PREBID_CONFIG & { consentManagement?: PbConsentManagement };

//@todo We recommend that the page first load a CMP stub synchronously, then asynchronously load the CMP code and the Prebid code
export const setPrebidConfig = (pbjs: Pbjs, consentFramework: string) => {
  const prebidConfig: PrebidConfig = { ...PREBID_CONFIG };
  if (consentFramework === 'TCF') {
    prebidConfig.consentManagement = {
      gdpr: {
        cmpApi: 'iab',
        timeout: 10000,
        actionTimeout: 10000,
        defaultGdprScope: true,
      },
      gpp: {
        cmpApi: 'iab',
        timeout: 10000,
      },
    };
  }
  pbjs.que.push(() => {
    pbjs.setConfig(prebidConfig);
  });
};

export const setPrebidAdUnits = (pbjs: Pbjs, prebidAdUnits: PrebidAdUnit[]) => {
  pbjs.que.push(() => {
    pbjs.addAdUnits(prebidAdUnits);
  });
};

export const removePrebidAdUnits = (pbjs: Pbjs, adUnitCodes: string[]): void => {
  pbjs.que.push(() => {
    pbjs.removeAdUnit(adUnitCodes);
  });
};

export const requestPrebidBids = (
  pbjs: Pbjs,
  bidsBackHandler = () => {},
  adUnitCodes?: string[],
) => {
  pbjs.que.push(() => {
    pbjs.requestBids({
      timeout: 1500,
      ...(Array.isArray(adUnitCodes) && { adUnitCodes }),
      bidsBackHandler: () => {
        pbjs.setTargetingForGPTAsync();
        bidsBackHandler();
      },
    });
  });
};
